import { dd, ddmm, ddmmyyyy } from '@/utils/date-to-string';

const isSameYear = (date1, date2) =>  {
  return date1.getFullYear() === date2.getFullYear();
};
const isSameMonths = (date1, date2) => {
  if (!isSameYear(date1, date2)) return false;

  return date1.getMonth() === date2.getMonth();
};

export default {
  methods: {
    getIntervalDates(intervalFrom, intervalTo) {
      const from = new Date(intervalFrom);
      const to = new Date(intervalTo);

      if (isSameMonths(from, to)) {
        return `${dd(from)} - ${ddmmyyyy(to)}`;
      } else if (isSameYear(from, to) && !isSameMonths(from, to)) {
        return `${ddmm(from)} - ${ddmmyyyy(to)}`;
      } else {
        return `${ddmmyyyy(from)} - ${ddmmyyyy(to)}`;
      }
    },
  }
}
